export default "__VITE_ASSET__BzSVDfq6__"